const page_schema = {
	"tiers": [
		{
			"name": "Categories",
			"type": "checkbox",
			"id": "categories",
			"class_name": "tags",
			"child_name": "categorie",
			"options": [
				{
					"name": "RNA-Seq",
					"id": "rna-seq"
				},
				{
					"name": "RT-PCR",
					"id": "rt-pcr"
				},
				{
					"name": "Ladders & Enzymes",
					"id": "ladders-and-enzymes"
				},
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "TaqMan Probe detection Compatibility",
					"id": "taqman-probe-detection-compatibility"
				},
				{
					"name": "SYBR green Compatibility",
					"id": "sybr-green-compatibility"
				},
				{
					"name": "Controls Available",
					"id": "controls-available"
				},
				{
					"name": "Ready-to Use Reagents",
					"id": "ready-to-use-reagents"
				},
				{
					"name": "rRNA depletion-based",
					"id": "rrna-depletion-based"
				},
				{
					"name": "Oligo-dT primer-based",
					"id": "oligo-dt-primer-based"
				},
				{
					"name": "Coding and a variety of non coding",
					"id": "coding-and-a-variety-of-non-coding"
				},
				{
					"name": "Coding only",
					"id": "coding-only"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "100 reactions/kit",
					"id": "100-reactions-kit"
				},
				{
					"name": "100, 1,000, and 10,000 reactions/kit",
					"id": "100-1000-and-10000-reactions-kit"
				},
				{
					"name": "12 Preps",
					"id": "12-preps"
				},
				{
					"name": "96 Preps",
					"id": "96-preps"
				},
			]
		},
		{
			"name": "Reaction Time",
			"type": "checkbox",
			"id": "reaction-times",
			"class_name": "tags",
			"child_name": "reaction-time",
			"options": [
				{
					"name": "15 minutes",
					"id": "15-minutes"
				},
				{
					"name": "< 1.5 hours",
					"id": "lt-15-hours"
				},
				{
					"name": "1.5 hours",
					"id": "15-hours"
				},
				{
					"name": "< 2 hours",
					"id": "lt-2-hours"
				},
			]
		},
		{
			"name": "Superior Sensitivity",
			"type": "checkbox",
			"id": "superior-sensitivitys",
			"class_name": "tags",
			"child_name": "superior-sensitivity",
			"options": [
				{
					"name": "As little as 0.1 pg of RNA",
					"id": "as-little-as-01-pg-of-rna"
				},
				{
					"name": "10 viral genome equivalent copies per reaction",
					"id": "10-viral-genome-equivalent-copies-per-reaction"
				},
				{
					"name": "15 viral genome equivalent copies per reaction",
					"id": "15-viral-genome-equivalent-copies-per-reaction"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Zymo-Seq SwitchFree 3′ mRNA Library Kit": {
			"title": "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
			"catalogNumbers": "R3008, R3009",
			"description": "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
			"handle": "/products/zymo-seq-switchfree-3-mrna-library-kit",
			"navigation_image": "https://files.zymoresearch.com/images/R3008Zymo-SeqSwitchFree3_mRNALibraryKit.webp",
			"generalIndex": "998",
			"id": "zymo-seq-switchfree-3-mrna-library-kit",
			"tags": [
				"rna-seq",
				"oligo-dt-primer-based",
				"coding-only",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"Zymo-Seq RiboFree Total RNA Library Kit": {
			"title": "Zymo-Seq RiboFree Total RNA Library Kit",
			"catalogNumbers": "R3000, R3003",
			"description": "One for all. Simplest and all-inclusive total RNA-Seq library preparation kit with universal rRNA depletion for any organism.",
			"handle": "/products/zymo-seq-ribofree-total-rna-library-kit",
			"navigation_image": "https://files.zymoresearch.com/images/R3000Zymo-SeqRiboFreeTotalRNALibraryKit.webp",
			"generalIndex": "998",
			"id": "zymo-seq-ribofree-total-rna-library-kit",
			"tags": [
				"rna-seq",
				"rrna-depletion-based",
				"coding-and-a-variety-of-non-coding",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"Zymo-Seq RiboFree Universal cDNA Kit": {
			"title": "Zymo-Seq RiboFree Universal cDNA Kit",
			"catalogNumbers": "R3001",
			"description": "Simplest NGS-Grade cDNA kit with universal rRNA depletion for any organism.",
			"handle": "/products/zymo-seq-ribofree-universal-cdna-kit?",
			"navigation_image": "https://files.zymoresearch.com/images/Zymo-SeqRiboFreeUniversalcDNAKit_Custom.webp",
			"generalIndex": "998",
			"id": "zymo-seq-ribofree-universal-cdna-kit?",
			"tags": [
				"rna-seq",
				"rrna-depletion-based",
				"12-preps",
				"coding-and-a-variety-of-non-coding",
			],
			filters: []
		},
		"Zymo-Seq UDI Primer Sets": {
			"title": "Zymo-Seq UDI Primer Sets",
			"catalogNumbers": "D3008, D3096, D3097, D3098",
			"description": "Can barcode any library containing TruSeq<sup>®</sup> adapters. Now available in a 10-bp format for multiplexing up to 192 libraries.",
			"handle": "/products/zymo-seq-udi-primer-sets?",
			"navigation_image": "https://files.zymoresearch.com/images/d3008_d3096_zymo-seq_udi_primer_set_Indexes_1-96.webp",
			"generalIndex": "998",
			"id": "zymo-seq-udi-primer-sets?",
			"tags": [
				"rna-seq",
				"rrna-depletion-based",
				"oligo-dt-primer-based",
				"coding-and-a-variety-of-non-coding",
				"coding-only",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
		"ZymoScript One-Step RT-qPCR Kit": {
			"title": "ZymoScript One-Step RT-qPCR Kit",
			"catalogNumbers": "R3014",
			"description": "RT-qPCR kit that allows simple and efficient one-step cDNA synthesis and qPCR amplification in a single reaction",
			"handle": "/products/zymoscript-one-step-rt-qpcr-kit",
			"navigation_image": "zymoscript",
			"generalIndex": "998",
			"id": "zymoscript-one-step-rt-qpcr-kit",
			"tags": [
				"rt-pcr",
				"taqman-probe-detection-compatibility",
				"sybr-green-compatibility",
				"ready-to-use-reagents",
				"15-hours",
				"as-little-as-01-pg-of-rna",
			],
			filters: []
		},
		"ZymoScript RT PreMix Kit": {
			"title": "ZymoScript RT PreMix Kit",
			"catalogNumbers": "R3012",
			"description": "Optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis",
			"handle": "/products/zymoscript-rt-premix-kit",
			"navigation_image": "zymoscript",
			"generalIndex": "998",
			"id": "zymoscript-rt-premix-kit",
			"tags": [
				"rt-pcr",
				"ready-to-use-reagents",
				"15-minutes",
				"as-little-as-01-pg-of-rna",
			],
			filters: []
		},
		"Quick SARS-CoV-2 rRT-PCR Kit": {
			"title": "Quick SARS-CoV-2 rRT-PCR Kit",
			"catalogNumbers": "R3011, R3011-1K, R3011-10K",
			"description": "Real-time rRT-PCR test (2 reactions/test) for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2). Versions for in vitro diagnostics (granted with CE-IVD and FDA EUA) as well as for RUO are available ",
			"handle": "/products/quick-sars-cov-2-rrt-pcr-kit",
			"navigation_image": "quick_sars_cov",
			"generalIndex": "998",
			"id": "quick-sars-cov-2-rrt-pcr-kit",
			"tags": [
				"rt-pcr",
				"controls-available",
				"ready-to-use-reagents",
				"lt-2-hours",
				"10-viral-genome-equivalent-copies-per-reaction",
			],
			filters: []
		},
		"Quick SARS-CoV-2 Multiplex Kit": {
			"title": "Quick SARS-CoV-2 Multiplex Kit",
			"catalogNumbers": "R3013, R3013-1K, R3013-10K",
			"description": "Real-time rRT-PCR test (1 reaction/test) for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2). Versions for in vitro diagnostics (granted with CE-IVD) as well as for RUO are available ",
			"handle": "/products/quick-sars-cov-2-multiplex-kit",
			"navigation_image": "quick_sars_cov",
			"generalIndex": "998",
			"id": "quick-sars-cov-2-multiplex-kit",
			"tags": [
				"rt-pcr",
				"controls-available",
				"ready-to-use-reagents",
				"100-reactions-kit",
				"lt-15-hours",
				"15-viral-genome-equivalent-copies-per-reaction",
			],
			filters: []
		},
		"ZR small-RNA Ladder": {
			"title": "ZR small-RNA Ladder",
			"catalogNumbers": "R1090",
			"description": "miRNA size marker for PAGE and small RNA size approximation",
			"handle": "/products/zr-small-rna-ladder",
			"navigation_image": "zr_small_rna_ladder",
			"generalIndex": "998",
			"id": "zr-small-rna-ladder",
			"tags": [
				"ladders-and-enzymes",
				"100-reactions-kit",
			],
			filters: []
		},
		"DNase I Set": {
			"title": "DNase I Set",
			"catalogNumbers": "E1010",
			"description": "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
			"handle": "/products/dnase-i-set",
			"navigation_image": "dnase",
			"generalIndex": "998",
			"id": "dnase-i-set",
			"tags": [
				"ladders-and-enzymes",
				"100-1000-and-10000-reactions-kit",
			],
			filters: []
		},
		"ZymoTaq PreMix": {
			"title": "ZymoTaq PreMix",
			"catalogNumbers": "E2003, E2004",
			"description": "Supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR.",
			"handle": "/products/zymotaq-premix",
			"navigation_image": "dna_polymerase",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"ladders-and-enzymes",
				"100-1000-and-10000-reactions-kit",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase": {
			"title": "ZymoTaq DNA Polymerase",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
			"handle": "/products/zymotaq-dna-polymerase",
			"navigation_image": "dna_polymerase",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"ladders-and-enzymes",
			],
			filters: []
		},
		"ZymoTaq qPCR Premix": {
			"title": "ZymoTaq qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "Contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays.",
			"handle": "/products/zymotaq-qpcr-premix",
			"navigation_image": "dna_polymerase",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"ladders-and-enzymes",
			],
			filters: []
		},
	}
}